module.exports = __webpack_public_path__ + "img/product1.1ef08f4b.png";